export const BUTTON_DATA: any = {
    REPORTING_MANAGER: [{
        name: 'Approve',
        class: 'btn btn-outline-primary',
        status: 'APPROVED',
        icon: 'fa-thumbs-up'
      },
      /* {
        name: 'Clarification needed',
        class: 'btn btn-outline-primary',
        status: 'CLARIFICATION NEEDED',
        icon: 'fa-comment',
        validationRequired: true
      }, */
      {
        name: 'Reject',
        class: 'btn btn-outline-danger',
        status: 'REJECTED',
        icon: 'fa-thumbs-down',
        validationRequired: true
      }],
      FACTORY_PROCUREMENT: [{
        name: 'Approve',
        class: 'btn btn-outline-primary',
        status: 'APPROVED',
        icon: 'fa-thumbs-up'
      },
      /* {
        name: 'Clarification needed',
        class: 'btn btn-outline-primary',
        status: 'CLARIFICATION NEEDED',
        icon: 'fa-comment',
        validationRequired: true
      }, */
      {
        name: 'Reject',
        class: 'btn btn-outline-danger',
        status: 'REJECTED',
        icon: 'fa-thumbs-down',
        validationRequired: true
      }]
};
